<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.0002C18.299 23.0002 23 18.2992 23 12.5002C23 6.70125 18.299 2.00024 12.5 2.00024C6.70101 2.00024 2 6.70125 2 12.5002C2 18.2992 6.70101 23.0002 12.5 23.0002ZM7.70725 18.7074L11.7072 14.7074L10.293 13.2931L6.29304 17.2931L7.70725 18.7074Z"
      fill="#2ED2BA"
    />
    <circle cx="14" cy="11.0002" r="4" stroke="white" stroke-width="2" />
  </svg>
</template>

<style scoped lang="postcss"></style>
